<div mat-dialog-title>
  <span>{{ 'POPUPS.EXPORT_DRILLDOWN_TITLE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">
  {{ error | translate }}
</q9-info-message>

<mat-dialog-content>
  <form [formGroup]="form" #formTemplate="ngForm">
    <q9-text-field
      formControlName="mapName"
      [label]="'POPUPS.EXPORT_DRILLDOWN_MAP_NAME_PLACEHOLDER'"></q9-text-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>

  <q9-primary-button
    [isLoading]="isLoading()"
    (click)="formTemplate.onSubmit($event); !isLoading() && onSubmit()">
    {{ 'POPUPS.EXPORT_DRILLDOWN_BTN' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
